<div *ngIf="
    (modoCampanha && (!cliente || !ativacao)) || (!modoCampanha && !cliente)
  " class="loading-box">
  <mat-spinner></mat-spinner>

  <div class="text">Aguarde um momento...</div>
</div>

<div class="cliente" *ngIf="(modoCampanha && cliente && ativacao) || (!modoCampanha && cliente)">
  <mat-list>
    <mat-list-item *ngIf="cliente?.publicacao_atual?.nome_campanha">
      <small matLine class="text-uppercase text-black-50"> campanha </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.publicacao_atual.nome_campanha }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.publicacao_atual?.nome_vendedor_publicado">
      <small matLine class="text-uppercase text-black-50">
        Nome do vendedor publicado
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.publicacao_atual?.nome_vendedor_publicado }}
        <span *ngIf="cliente?.publicacao_atual?.loja">
          - {{ cliente?.publicacao_atual?.loja }}</span>
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="
    cliente?.opt_in_email != null ||
    cliente?.opt_in_sms != null ||
    cliente?.opt_in_wpp != null ||
    cliente?.opt_in_telemkt != null
">
      <small matLine class="text-uppercase text-black-50">Status das Mídias</small>

      <h5 matLine class="font-weight-bold text-cinza" *ngIf="cliente?.opt_in_email != null">
        <strong>Receber Email:</strong>
        <span [ngClass]="cliente.opt_in_email ? 'text-success' : 'text-danger'">
          {{ cliente.opt_in_email ? 'Sim' : 'Não' }}
        </span>
      </h5>

      <h5 matLine class="font-weight-bold text-cinza" *ngIf="cliente?.opt_in_sms != null">
        <strong>Receber SMS:</strong>
        <span [ngClass]="cliente.opt_in_sms ? 'text-success' : 'text-danger'">
          {{ cliente.opt_in_sms ? 'Sim' : 'Não' }}
        </span>
      </h5>

      <h5 matLine class="font-weight-bold text-cinza" *ngIf="cliente?.opt_in_wpp != null">
        <strong>Receber WhatsApp:</strong>
        <span [ngClass]="cliente.opt_in_wpp ? 'text-success' : 'text-danger'">
          {{ cliente.opt_in_wpp ? 'Sim' : 'Não' }}
        </span>
      </h5>

      <h5 matLine class="font-weight-bold text-cinza" *ngIf="cliente?.opt_in_telemkt != null">
        <strong>Receber TeleMarketing:</strong>
        <span [ngClass]="cliente.opt_in_telemkt ? 'text-success' : 'text-danger'">
          {{ cliente.opt_in_telemkt ? 'Sim' : 'Não' }}
        </span>
      </h5>
    </mat-list-item>


    <mat-list-item>
      <small matLine class="text-uppercase text-black-50"> cpf/cnpj cliente </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{
        cliente?.cpf?.length === 14
        ? (cliente?.cpf | mask : '00.000.000/0000-00')
        : (cliente?.cpf | mask : '000.000.000-00')
        }}
      </h5>
    </mat-list-item>
    <mat-list-item *ngIf="cliente.nome">
      <small matLine class="text-uppercase text-black-50"> nome cliente </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.nome }}
      </h5>
    </mat-list-item>
    <mat-list-item *ngIf="cliente.segmento">
      <small matLine class="text-uppercase text-black-50"> segmento </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.segmento }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.loja_preferencial">
      <small matLine class="text-uppercase text-black-50">
        loja de preferência
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.loja_preferencial }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.cidade">
      <small matLine class="text-uppercase text-black-50"> Cidade </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.cidade }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.vendedor_preferencial">
      <small matLine class="text-uppercase text-black-50">
        vendedor de preferência
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.vendedor_preferencial }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.categoria_preferencial">
      <small matLine class="text-uppercase text-black-50">
        categoria de preferência
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.categoria_preferencial }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.saldo_crm_bonus">
      <small matLine class="text-uppercase text-black-50"> saldo crm </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.saldo_crm_bonus }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.rfv">
      <small matLine class="text-uppercase text-black-50"> rfv </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.rfv }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.safra_co_hort">
      <small matLine class="text-uppercase text-black-50">
        safra co-hort
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.safra_co_hort }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.dt_nascimento">
      <small matLine class="text-uppercase text-black-50">
        data de aniversário
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.dt_nascimento | date : "dd/MM/yyyy" }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.genero_preferencia">
      <small matLine class="text-uppercase text-black-50">
        genero de preferência
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ cliente?.genero_preferencia }}
      </h5>
    </mat-list-item>

    <mat-list-item *ngIf="cliente?.dt_ultima_compra">
      <small matLine class="text-uppercase text-black-50">
        Quantidade de dias desde última compra
      </small>
      <h5 matLine class="font-weight-bold text-cinza">
        {{ calcDias(cliente?.dt_ultima_compra) }}
      </h5>
    </mat-list-item>
  </mat-list>

  <div class="p-1">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="text-uppercase text-black-50">
              <small>Últimas Compras</small>
            </div>
            <div class="font-weight-bold pt-1" *ngIf="cliente?.vlr_compras_12_meses">
              {{ valorReal(cliente?.vlr_compras_12_meses) }}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngFor="let compra of getArray(cliente?.ultimas_compras) | orderBy">
          <app-list-head [matIconName]="'shopping_bag'" [subTitle]="compra.data_compra | date"
            [title]="compra.loja"></app-list-head>

          <app-mini-card borderColor="black" backgroundColor="gray" textAndIconColor="white"
            [text]="compra.vendedor.split(' ').slice(0, 2).join(' ')" matIconName="person"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="compra.canal" [text]="getCanal(compra.canal)" matIconName="campaign"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="compra.vlr_compra" [text]="valorReal(compra.vlr_compra)" matIconName="payments"></app-mini-card>

          <app-mini-card *ngIf="compra.compra_influenciada" borderColor="green" backgroundColor="rgb(152, 232, 152)"
            textAndIconColor="black" [text]="'Venda influenciada'" matIconName="forum"></app-mini-card>

          <div class="container" *ngIf="compra.itens && isArray(compra.itens)">
            <div class="text-black-50" *ngFor="let item of compra.itens">
              <small class="d-block">• <span *ngIf="item.troca"><b> Troca: </b></span>
                <span *ngIf="item.qtd"> {{ item.qtd }} </span><span *ngIf="item.produto"> {{ item.produto }}
                </span><span *ngIf="item.tamanho"> | Tam: {{ item.tamanho }} </span>
                <span *ngIf="item.ref"> | Ref: {{ item.ref }} </span>
              </small>
            </div>
          </div>

          <mat-divider></mat-divider>
          <br />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="text-center" *ngIf="mensagemDescadastro">
      <div class="alert alert-warning">
        Descadastro feito com sucesso. O cliente não receberá mais mensagens.
      </div>
    </div>
    <div *ngIf="showDescadastroBusca" class="p-3 text-center">
      <button (click)="descadastrarCliente()" class="w-50 mb-2 text-uppercase btn" [ngClass]="
          'btn-cancel-' +
          securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
        " color="warn">
        descadastrar</button><br />
    </div>
  </div>

  <div class="p-1" *ngIf="cliente?.ultimas_ativacoes">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="text-uppercase text-black-50">
              <small>Últimas Ativações</small>
            </div>

            <div *ngIf="cliente?.ultimas_ativacoes?.length == 1" class="font-weight-bold pt-1">
              {{ cliente?.ultimas_ativacoes?.length }} ATIVAÇÃO
            </div>
            <div *ngIf="cliente?.ultimas_ativacoes?.length > 1" class="font-weight-bold pt-1">
              {{ cliente?.ultimas_ativacoes?.length }} ATIVAÇÕES
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngFor="let ativacao of cliente?.ultimas_ativacoes">
          <app-list-head [matIconName]="'forum'" [subTitle]="ativacao.data_ativacao | date"
            [title]="ativacao.nome_campanha" *ngIf="!ativacao.tipo"></app-list-head>

          <app-list-head [matIconName]="'smartphone'" [subTitle]="ativacao.data_ativacao | date"
            [title]="ativacao.nome_campanha" *ngIf="ativacao.tipo == 'direto'"></app-list-head>

          <app-list-head [matIconName]="'mail'" [subTitle]="ativacao.data_ativacao | date"
            [title]="ativacao.nome_campanha" *ngIf="ativacao.tipo == 'email'"></app-list-head>

          <app-list-head [matIconName]="'sms'" [subTitle]="ativacao.data_ativacao | date"
            [title]="ativacao.nome_campanha" *ngIf="ativacao.tipo == 'sms'"></app-list-head>

          <app-mini-card *ngIf="ativacao.nome_vendedor_ativador" borderColor="black" backgroundColor="gray"
            textAndIconColor="white" [text]="
              ativacao?.nome_vendedor_ativador?.split(' ').slice(0, 2).join(' ')
            " matIconName="person"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="ativacao.tipo == 'direto'" text="Direto" matIconName="smartphone"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="ativacao.tipo == 'sms'" text="SMS" matIconName="sms"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="ativacao.tipo == 'email'" text="E-mail" matIconName="mail"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="ativacao.tipo == 'email' && ativacao.abriu == true" text="Abriu"
            matIconName="open_in_full"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="ativacao.tipo == 'email' && ativacao.abriu == false" text="Não abriu"
            matIconName="open_in_full"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="ativacao.tipo == 'email' && ativacao.clicou == true" text="Clicou"
            matIconName="ads_click"></app-mini-card>

          <app-mini-card borderColor="black" backgroundColor="rgb(177, 177, 177)" textAndIconColor="white"
            *ngIf="ativacao.tipo == 'email' && ativacao.clicou == false" text="Não clicou"
            matIconName="ads_click"></app-mini-card>

          <mat-divider></mat-divider>
          <br />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="text-center" *ngIf="mensagemDescadastro">
      <div class="alert alert-warning">
        Descadastro feito com sucesso. O cliente não receberá mais mensagens.
      </div>
    </div>

    <div *ngIf="showDescadastroBusca" class="p-3 text-center">
      <button (click)="descadastrarCliente()" class="w-50 mb-2 text-uppercase btn" [ngClass]="
          'btn-cancel-' +
          securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
        " color="warn">
        descadastrar</button><br />
    </div>
  </div>

  <div class="menu">
    <button mat mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item (click)="openNotas('LEMBRETE')">
        <mat-icon style="color: black">notifications</mat-icon>
        <span style="color: black">LEMBRETES</span>
      </button>

      <button *ngIf="
          currentVendedorInfo?.id_crm ==
          cliente?.id_vendedor_preferencia
        " mat-menu-item (click)="openNotas('ANOTACAO')">
        <mat-icon style="color: black">notes</mat-icon>
        <span style="color: black">ANOTAÇÕES</span>
      </button>
    </mat-menu>
  </div>
</div>

<div class="text-center" style="margin-top: 16px" *ngIf="!cliente.nome">
  <div style="margin-bottom: 0px" class="alert alert-warning">
    Esse cliente está com dados incompletos, o suporte já foi notificado para
    realizar sua atualização. Ainda sim, você poderá realizar sua ativação
    abaixo.
  </div>
</div>

<div class="text-center" style="margin-top: 16px" *ngIf="ativacao && !hasWhatsapp">
  <div style="margin-bottom: 0px" class="alert alert-warning">
    Esse cliente não possui informações de whatsapp. Ainda sim, se desejar, você
    poderá realizar sua ativação abaixo por ligação, confirmar contato e
    encerrar.
    <br />
    <br />

    Ou, se preferir, poderá clicar em "Encerrar" e decidir se deseja finalizar
    sem ativação ou mover para o final da fila.
  </div>
</div>

<div *ngIf="
    (modoCampanha &&
      !securityService.currentUserValue.status_bloqueio?.bloqueado &&
      cliente &&
      ativacao) ||
    (!modoCampanha &&
      !securityService.currentUserValue.status_bloqueio?.bloqueado &&
      cliente)
  " class="acoes pt-3 pb-0 text-center">
  <div *ngIf="ativacao && !ativacao?.finalizada">
    <div class="buttons" *ngFor="let midia of ativacao?.midias">
      <button (click)="abrirDialogMidia(ativacao, midia)" *ngIf="midia.tipo_midia === 'whatsapp'"
        class="w-50 mb-2 text-uppercase btn" [ngClass]="
          'btn-action-' +
          securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
        ">
        whatsapp
      </button>
      <button (click)="abrirDialogMidia(ativacao, midia)" *ngIf="midia.tipo_midia === 'telefone'"
        class="w-50 mb-2 text-uppercase btn" [ngClass]="
          'btn-action-' +
          securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
        ">
        ligação
      </button>
    </div>
  </div>

  <button (click)="descadastrarClienteCanal()" class="w-50 mb-2 text-uppercase btn" [ngClass]="
      'btn-cancel-' +
      securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
    " color="warn">
    descadastrar</button><br />

  <button *ngIf="
      cliente?.id_vendedor_preferencia === currentVendedorInfo?.id_crm &&
      !cliente?.publicacao_atual?.ind_publicado &&
      cliente?.telefone &&
      cliente.opt_in_wpp
    " (click)="openDialogAtvEsp()" class="w-50 mb-2 text-uppercase btn" [ngClass]="
      'btn-cancel-' +
      securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
    " color="warn">
    Ativação Espontânea</button><br *ngIf="
      cliente?.id_vendedor_preferencia === currentVendedorInfo?.id_crm &&
      !cliente?.publicacao_atual?.ind_publicado &&
      cliente?.telefone &&
      cliente.opt_in_wpp
    " />

  <button *ngIf="ativacao && !ativacao?.finalizada" (click)="encerrarAtivacao(ativacao)"
    class="w-50 mb-2 text-uppercase btn" [ngClass]="
      'btn-cancel-' +
      securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
    ">
    encerrar
  </button>
</div>